// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputRange_wrapper__ATz_o","withoutMargin":"InputRange_withoutMargin__v_kA4","separator":"InputRange_separator__6LvEf"};